import wrappedAxios from "../axiosWrapper";
import * as UP from "./urlParsers";
import * as PT from "./types";

export const getFile = (params: PT.GetFileParams) =>
  wrappedAxios<string>({
    url: UP.getFile(params),
    method: "get",
  });

export const getFiles = (params: PT.GetFilesParams) =>
  wrappedAxios<PT.FileMetadata[]>({
    url: UP.getFiles(params),
    method: "get",
  });

export const requestUploadFile = ({
  fileDto,
  ...rest
}: PT.UploadFileParams) => {
  wrappedAxios({
    url: UP.uploadFile(rest),
    method: "post",
    data: fileDto,
  });
};

export const requestUploadFiles = ({
  filesDto,
  ...rest
}: PT.UploadFilesParams) =>
  wrappedAxios<PT.FileHandleResponse>({
    url: UP.uploadFiles(rest),
    method: "post",
    data: filesDto,
  });

export const requestDeleteFile = (params: PT.DeleteFileParams) => {
  wrappedAxios({
    url: UP.deleteFile(params),
    method: "delete",
  });
};

export const requestDeleteFiles = (
  fileIds: string[],
  params: PT.DeleteFilesParams
) =>
  wrappedAxios<PT.FileHandleResponse>({
    url: UP.deleteFiles(params),
    method: "delete",
    data: fileIds,
  });
